import script from "./ConsultingProjects.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConsultingProjects.vue?vue&type=script&setup=true&lang=ts"

import "./ConsultingProjects.vue?vue&type=style&index=0&id=4f6ee02a&lang=less&scoped=true"

import exportComponent from "/home/runner/work/Portfolio/Portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f6ee02a"]])

export default __exports__